import React from "react";
import {
  alpha,
  ThemeProvider,
  withStyles,
  makeStyles,
  createTheme,
} from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import { green } from "@material-ui/core/colors";
import { InputAdornment } from "@material-ui/core";
import "./inputField.scss";
import MailIcon from "../../icons/mail_email.svg";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "red",
      },
      "&:hover fieldset": {
        borderColor: "yellow",
      },
      "&.Mui-focused fieldset": {
        borderColor: "green",
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function InputField({
  value,
  onChangeValue,
  label,
  isPassword,
  icon,
  onKeyDown,
}) {
  const classes = useStyles();

  return (
    <div className="custom-text-field-dexter">
      {icon && <img src={icon} />}

      <TextField
        style={{ width: "80%" }}
        label={label}
        type={isPassword ? "password" : "text"}
        id="filled-size-normal"
        value={value}
        onChange={onChangeValue}
        onKeyDown={onKeyDown}
        variant="filled"
      />
    </div>
  );
}
